import axios from 'axios';

const LIST_FEEDBACK_ENDPOINT = process.env.REACT_APP_API_LIST_FEEDBACK_ENDPOINT;
const SEND_FEEDBACK_ENDPOINT = process.env.REACT_APP_API_SEND_FEEDBACK_ENDPOINT;

export const getAll = async (token) => {
    try {
        const response = await axios.get(LIST_FEEDBACK_ENDPOINT, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        return response.data.object;
    } catch (error) {
        console.error('Erro ao buscar feedbacks:', error);
        throw error;
    }
}

export const registerFeedback = async (token, messageId, feedback, feedbackType, remove = false) => {
    try {
        await axios.post(SEND_FEEDBACK_ENDPOINT, {
            messageId: messageId,
            feedback: feedback,
            remove: remove,
            feedbackType: feedbackType
        }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }
    catch (error) {
        console.error('Error in API call:', error);
        throw error;
    }
}


